import {SET_PROVIDER_INFO} from './login.action';

const initialState = {
    provider_info:null
};

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_PROVIDER_INFO:
        return Object.assign({}, state, {
            provider_info: action.payload
          });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/app/login_page/user.reducer.js